import { useMobileSize } from 'hooks/mobile-size';
import PropTypes from 'prop-types';

import { BottomSheet } from 'components/BottomSheet/BottomSheet';
import { Drawer } from 'components/Drawer/Drawer';

// Mobile renders a bottom sheet, desktop a side drawer; neither can be dismissed except by confirming,
// unless canClose is set (a problem outside the ID that the candidate must fix elsewhere).
export const ConfirmDetailsSheet = ({
  open,
  canClose = false,
  onClose,
  title,
  description,
  children,
  footer,
  dataTestId,
}) => {
  const { mobile } = useMobileSize();

  if (mobile) {
    return (
      <BottomSheet
        open={open}
        disableClose={!canClose}
        onClose={onClose}
        title={title}
        description={description}
        footer={footer}
        dataTestId={dataTestId}>
        {children}
      </BottomSheet>
    );
  }

  return (
    <Drawer
      open={open}
      disableClose={!canClose}
      onClose={onClose}
      title={title}
      description={description}
      dataTestId={dataTestId}>
      <Drawer.Body>{children}</Drawer.Body>
      {footer && (
        <Drawer.Footer className="flex flex-col items-center gap-3">{footer}</Drawer.Footer>
      )}
    </Drawer>
  );
};

ConfirmDetailsSheet.propTypes = {
  open: PropTypes.bool.isRequired,
  canClose: PropTypes.bool,
  onClose: PropTypes.func,
  title: PropTypes.string,
  description: PropTypes.string,
  children: PropTypes.node,
  footer: PropTypes.node,
  dataTestId: PropTypes.string,
};
